// extracted by mini-css-extract-plugin
module.exports = {"address_icon":"ExamApplicationDetails_address_icon__141vG","reviewText":"ExamApplicationDetails_reviewText__3SmOb","link":"ExamApplicationDetails_link__3XyXs"};